import Vue from "vue";
import VueRouter from "vue-router";
import { auth } from "../firebase";
import "animate.css";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LoadingTo",
    component: () => import("../views/LoadingTo.vue"),
    meta: {
      autentificado: false,
    },
  },
  {
    path: "/landing",
    name: "Landing",
    component: () => import("../views/Landing.vue"),
    meta: {
      autentificado: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Usuario/Login.vue"),
    meta: {
      autentificado: false,
    },
  },
  {
    path: "/registrarse",
    name: "Registrarse",
    component: () => import("../views/Usuario/Registrarse.vue"),
    meta: {
      autentificado: false,
    },
  },
  {
    path: "/inicio",
    name: "Inicio",
    component: () => import("../views/Inicio.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/trivia",
    name: "Trivia",
    component: () => import("../views/Trivia.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/creacionPreguntasTrivia",
    name: "CreacionPreguntasTrivia",
    component: () => import("../views/Ranking/Ranking.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/triviapersonalizada/:idSala",
    name: "TriviaPersonalizada",
    component: () => import("../views/TriviaPersonalizada.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/salas",
    name: "Salas",
    component: () => import("../views/Salas.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/registrosala",
    name: "RegistroSala",
    component: () => import("../views/RegistroSala.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/editarsala/:id",
    name: "EditarSala",
    component: () => import("../views/EditarSala.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: () => import("../views/Perfil/Perfil.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/ranking/menu",
    name: "RankingMenu",
    component: () => import("../views/Ranking/Ranking.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/ranking/oro",
    name: "RankingOro",
    component: () => import("../views/Ranking/Oro.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/ranking/plata",
    name: "RankingPlata",
    component: () => import("../views/Ranking/Plata.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/ranking/bronce",
    name: "RankingBronce",
    component: () => import("../views/Ranking/Bronce.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/ranking/general",
    name: "Ranking",
    component: () => import("../views/Ranking/General.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/ranking/sala",
    name: "RankingSala",
    component: () => import("../views/Ranking/Sala.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/preguntas/:id",
    name: "Preguntas",
    component: () => import("../views/Preguntas/Preguntas.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/preguntas/editar/:id",
    name: "EditarPreguntas",
    component: () => import("../views/Preguntas/Editar.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/fuentes",
    name: "Fuentes",
    component: () => import("../views/Fuentes.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/Landing.vue"),
    meta: {
      autentificado: false,
    },
  },
  {
    path: "/salaSofu",
    name: "SalaSofu",
    component: () => import("../views/SalaSofu.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/salaJugadores",
    name: "SalaJugadores",
    component: () => import("../views/SalaJugadores.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/salaPersonalizada",
    name: "SalaPersonalizada",
    component: () => import("../views/SalaPersonalizada.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/:idSala/SalaDeEspera/:idPartida/",
    name: "SalaDeEspera",
    component: () => import("../views/Partida/SalaDeEspera.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/:idSala/RegistroPartida",
    name: "RegistroPartida",
    component: () => import("../views/Partida/RegistroPartida.vue"),
    meta: {
      autentificado: true,
    },
  },
  {
    path: "/:idSala/TriviaPartida/:idPartida/",
    name: "TriviaPartida",
    component: () => import("../views/Partida/TriviaPartida.vue"),
    meta: {
      autentificado: true,
    },
  },
];

// INSTANCIA DE VUE ROUTER
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  let usuario = auth.currentUser;
  let autorizacion = to.matched.some((record) => record.meta.autentificado);
  if (autorizacion && !usuario) {
    next("/login");
  } else if (!autorizacion && usuario) {
    next();
  } else {
    next();
  }
});
export default router;
